import { FileChartIcon } from './FileChartIcon';

/**
 * author: Simran
 * id 303BB890-634F-405C-B77C-4AC831BCAEC4
 * name file-chart
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-chart.svg
 * tags
 * - Files / Folders 
 */
export const FileGraphIcon = FileChartIcon;
export default FileGraphIcon